import React from 'react';
import Select from 'react-select';

const MeasurementUnitSelector = ({ units = [], selectedUnitId = null, onChange, ...props }) => {
    const safeUnits = units || [];

    const options = safeUnits.map(unit => ({
        value: unit.quantitativeMeasurementUnitId,
        label: unit.quantitativeMeasurementUnitName
    }));

    const selectedOption = selectedUnitId ? options.find(option => option.value === selectedUnitId) : null;

    const handleChange = (selectedOption) => {
        if (selectedOption && selectedOption.value) {
            const unitSelected = safeUnits.find(unit => unit.quantitativeMeasurementUnitId === selectedOption.value);
            onChange(unitSelected);
        }
    };

    return (
        <Select
            value={selectedOption}
            onChange={handleChange}
            options={options}
            {...props}
        />
    );
};

export default MeasurementUnitSelector;